module.exports = __webpack_public_path__ + "ramiro-9582f143432e805ab1e68466750dedfc.webp";